/**
 * Renders a video component with all tracks
 */

import React from 'react';

// Components
import * as icons from '../../ui/Icons';
import ProgressBar from './ProgressBar';

class Video extends React.Component {
  constructor() {
    super();

    // Set the initial state
    this.state = {
      flagged: false,
      flags: [],
      highlights: [],
      tracks: []
    };

    // Bind this to functions
    this.toggleFlag = this.toggleFlag.bind(this);
  }

  componentDidMount() {
    const {
      onInfo,
      onSeek,
      prepareFlags,
      prepareHighlights,
      session,
      solo,
      videos
    } = this.props;
    const tracks = [];

    Object.keys(videos).forEach(track => {
      tracks.push(videos[track]);
    });

    this.setState({
      tracks
    });

    // Set up progress bar highlight areas and flags
    const { annotations } = session.automated;

    prepareFlags(annotations, this);

    if (!solo) {
      prepareHighlights(annotations, this);
    }

    // Show session details by default if solo
    if (solo && onInfo) {
      setTimeout(() => {
        onInfo({
          examSid: session.examSid,
          installSid: session.installSid,
          sessionSid: session.sid,
          session: session,
          flags: this.state.flags,
          onSeek
        });
      })
    }
  }

  componentDidUpdate(prevProps) {
    const { current, isPlaying, playSpeed, seeked, volume } = this.props;

    // Toggle play status and play speed
    if (prevProps.isPlaying !== isPlaying || prevProps.playSpeed !== playSpeed) {
      this.togglePlay();
    }

    // Update current time
    if (prevProps.current !== current && seeked) {
      this.updateCurrentTime();
    }

    // Update volume
    if (prevProps.volume !== volume) {
      this.updateVolume();
    }
  }

  togglePlay() {
    const { isPlaying, playSpeed } = this.props;
    const { tracks } = this.state;
    let i = 0;
    let trackEl = null;

    // for(let i = 0; i < 1; i++) {
    for (i = 0; i < tracks.length; i++) {
      trackEl = this[`video-${i}`];

      trackEl.playbackRate = playSpeed;

      if (isPlaying) {
        trackEl.play();
      } else {
        trackEl.pause();
      }
    }
  }

  updateCurrentTime() {
    const { current } = this.props;
    const { tracks } = this.state;
    let i = 0;
    let trackEl = null;

    for (i = 0; i < tracks.length; i++) {
      trackEl = this[`video-${i}`];

      trackEl.currentTime = current;
    }
  }

  updateVolume() {
    const { volume } = this.props;
    const { tracks } = this.state;
    let i = 0;
    let trackEl = null;

    for (i = 0; i < tracks.length; i++) {
      trackEl = this[`video-${i}`];

      trackEl.volume = volume;
    }
  }

  toggleFlag(state) {
    this.setState({
      flagged: state || !this.state.flagged
    });
  }

  render() {
    const { flagged, flags, highlights, tracks } = this.state;
    const {
      current,
      duration,
      // onIncident,
      onInfo,
      onInit,
      onPlay,
      onSeek,
      session,
      solo,
      translation
    } = this.props;

    return (
      <article
        className={`video${solo ? '' : ' video--progress'}${flagged ? ' video--flagged' : ''}`}
      >
        {tracks.length > 0 &&
          <ul className="video__tracks">
            {tracks.map((track, i) =>
              <li
                className="video__track"
                key={i}
              >
                <div className="video__wrap">
                  <video
                    id={`video-${i}`}
                    ref={(el) => this[`video-${i}`] = el}
                    className="video__picture"
                    src={track.url}
                    // onLoadedMetadata={(e) => {
                    //   // TEMP
                    //   // Chrome is dumb about duration on
                    //   // webm, so this is a temporary fix
                    //   const video = e.target;
                    //   video.currentTime = 9999999;

                    //   setTimeout(() => {
                    //     video.currentTime = 0;
                    //   }, 500);
                    // }}
                    onDurationChange={(e) => onInit(Math.round(e.target.duration))}
                  ></video>
                </div>
              </li>
            )}
          </ul>
        }

        {/* Session details button */}
        <ul className="video__tools">
          <li>
            <button
              className="video__tool video__info"
              type="button"
              title={translation.info}
              onClick={() => onInfo({
                examSid: session.examSid,
                installSid: session.installSid,
                sessionSid: session.sid,
                session: session,
                flags: this.state.flags,
                onSeek
              })}
            >
              <icons.infoCircle />

              <span>{translation.info}</span>
            </button>
          </li>
          {/* <li>
            <button
              className="video__tool video__info"
              type="button"
              title={translation.info}
              onClick={() => onIncident(session)}
            >
              <icons.warningCircle />

              <span>{translation.report}</span>
            </button>
          </li> */}
        </ul>

        {!solo &&
          <div className="video__progress">
            <ProgressBar
              {...this.props}
              current={current}
              duration={duration}
              flags={flags}
              highlights={highlights}
              onPlay={onPlay}
              onFlag={this.toggleFlag}
              readOnly={true}
            />
          </div>
        }
      </article>
    )
  }
};

export default Video;
